import { Box, Text } from '@factorialco/deprecated-design-system'

import UserAvatar from 'modules/core/components/UserAvatar'

import { type ResoureRelationShip } from 'modules/processes/domain'
import { isMaterializedProcessCompleted } from 'modules/processes/lib/materializedProcess'

export const labelColor = (status?: string | null) => {
  if (!status) return 'grey600'

  return isMaterializedProcessCompleted(status) ? 'grey600' : undefined
}

export const MaterializedProcessName = (
  name: string,
  status: string,
  resourceRelationships?: ResoureRelationShip[] | null
) => {
  const access = resourceRelationships?.at(0)?.access

  return (
    <Box gap="s12" flexDirection="row" alignItems="center">
      <Box position="relative">
        {isMaterializedProcessCompleted(status) && (
          <Box
            width="full"
            height="full"
            background="grey200"
            borderRadius={{ all: 'rel333' }}
            style={{
              position: 'absolute',
              zIndex: '1',
              opacity: '50%',
            }}
          />
        )}
        {access && <UserAvatar user={access} size="s32" />}
      </Box>
      <Text.Normal lineClamp={2} color={labelColor(status)}>
        {name}
      </Text.Normal>
    </Box>
  )
}
